import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import MessageHelperModal from '../modals/MessageHelperModal.vue';
Vue.use(BootstrapVue);
Vue.component('MessageHelperModal', MessageHelperModal);

class MessageService {
    async showResponseMessage(detailed, info) {
        const vue = new Vue();
        const h = vue.$createElement;
        const contentVNode = h('message-helper-modal', {
            class: ['mx-2'],
            id: ['test-component'],
            props: {
                variant: info.variant ? info.variant : 'info',
                statusCode: info.statusCode,
                statusText: info.statusText,
                timestamp: info.timestamp,
                message:  info.message,
                content: info.content,
                url: info.url,
                detailed
            }
        });
        await vue.$bvModal.msgBoxOk([contentVNode], { title: info.title,
            size:'lg',
            centered: true,
            okTitle: 'Cerrar',
            okVariant: info.variant,
            headerBgVariant: info.variant,
            headerTextVariant: info.variant === 'warning' ? 'black' : 'white',
            bodyBgVariant: 'white',
            footerBgVariant: 'sidebar'
        });
        vue.$destroy();
    }

    async msgOk(title, message, okTitle = 'Cerrar', okVariant = 'success') {
        const vue = new Vue();
        await vue.$bvModal.msgBoxOk(message, {
            title,
            buttonSize: 'sm',
            headerBgVariant: 'success',
            headerTextVariant: 'white',
            centered: true,
            okTitle,
            okVariant,
        })

        vue.$destroy();
    }

    async msgConfirm(title, message, okTitle = 'Aceptar', cancelTitle = 'cancel', okVariant = 'primary', cancelVariant = 'outline-dark', headerBgVariant = 'info', headerTextVariant = 'white') {
        const vue = new Vue();
        const result = await vue.$bvModal.msgBoxConfirm(message, {
            title,
            buttonSize: 'sm',
            centered: true,
            okTitle,
            cancelTitle,
            okVariant,
            cancelVariant,
            bodyBgVariant: 'white',
            headerBgVariant,
            headerTextVariant
        });

        vue.$destroy();
        return result;
    }
}

export default new MessageService();